import { mapState, mapMutations, mapActions, mapGetters } from 'vuex';

/**
 * WebSocket 輔助 Mixin（輕量級）
 * 
 * 此 mixin 不再管理 WebSocket 的生命周期
 * WebSocket 由 App.vue 統一管理，各組件只使用共享的連接
 */
export const mixinWebsocket = {

    computed: {
        ...mapState('account', ['status', 'user']),
        ...mapState('ws', ['wsState', 'socket', 'wsNotify']),
        ...mapGetters('ws', ['isConnected'])
    },

    methods: {
        ...mapMutations('ws', ['setWsNotify', 'setWsState', 'sendMessage']),
        ...mapActions('ws', ['initWebsocket', 'closeWebSocket']),

        /**
         * 發送 WebSocket 訊息（便捷方法）
         */
        websocketsend(data) {
            if (!this.isConnected) {
                console.warn('WebSocket 尚未連線，無法發送');
                return false;
            }

            try {
                this.sendMessage(data);
                return true;
            } catch (error) {
                console.error('WebSocket 發送失敗:', error);
                return false;
            }
        },

        /**
         * 查看目前 WebSocket 狀態（便捷方法）
         */
        websocketstate() {
            if (!this.socket) {
                console.log('WebSocket: null');
                return;
            }

            const state = {
                0: 'CONNECTING',
                1: 'OPEN',
                2: 'CLOSING',
                3: 'CLOSED'
            };

            console.log(
                'WebSocket 狀態:',
                state[this.socket.readyState]
            );
        },

        /**
         * 手動重新連接（便捷方法）
         * 通常不需要調用，WebSocket 會自動重連
         */
        reconnectWebsocket() {
            console.log('手動觸發 WebSocket 重連');
            this.initWebsocket();
        }
    }

    // 移除 beforeDestroy 鉤子
    // WebSocket 生命周期由 App.vue 統一管理
};